import { OpenSearchLogFilterCriteriaDTO } from 'data/log/log.types';
import { exportLogs } from 'data/log/log.api';

const exportLogsToFile = async (filterCriteria: OpenSearchLogFilterCriteriaDTO, setCompletedStatus: (a: boolean) => void) => {
    try {
        const response = await exportLogs(filterCriteria);
        // Create a URL for the file and download it
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
        const filename = `logs_export_${timestamp}.log`;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to export logs:', error);
    } finally {
        setCompletedStatus(false);
    }
};

export default exportLogsToFile;
